import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './_guards/auth-guard.service';
import { RegisterComponent } from './register/register.component';
import { LearningBasicsComponent } from './learning/learning-basics/learning-basics.component';
import { LearningDrawingComponent } from './learning/learning-drawing/learning-drawing.component';
import { LearningSearchComponent } from './learning/learning-search/learning-search.component';
import { LearningDraftComponent } from './learning/learning-draft/learning-draft.component';
import { LearningFilingComponent } from './learning/learning-filing/learning-filing.component';
import { TestBasicsComponent } from './test/test-basics/test-basics.component';
import { TestSearchComponent } from './test/test-search/test-search.component';
import { TestDraftComponent } from './test/test-draft/test-draft.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PatentSearchComponent } from './patent-search/patent-search.component';
import { AddressComponent } from './address/address.component';
import { DashboardUserComponent } from './dashboard-user/dashboard-user.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { BasicInventionDetailsSaveUpdateComponent } from './basic-invention-details-save-update/basic-invention-details-save-update.component';
import { PatentDraftSaveUpdateComponent } from './patent-draft-save-update/patent-draft-save-update.component';
import { NdaComponent } from './nda/nda.component';
import { PreviewComponent } from './preview/preview.component';
import { PatentDrawingSaveUpdateComponent } from './patent-drawing-save-update/patent-drawing-save-update.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { InventionResolver } from './_services/invention-resolver-service';
import { ConfirmationGuard } from './_guards/confirmation.guard';
import { PatentFilingProcessComponent } from './patent-filing-process/patent-filing-process.component';

const routes: Routes = [
  // LogIn
  {
    path: 'login', component: LoginComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'logout', component: LoginComponent },
      { path: '**', component: LoginComponent },
    ]
  },
  { path: 'register', component: RegisterComponent },
  {
    path: 'main', component: NavbarComponent, canActivate: [AuthGuardService],
    children: [
      { path: 'changePassword', component: ChangePasswordComponent, canActivateChild: [AuthGuardService] },
      // Dashboard Admin
      { path: 'dashboard', component: DashboardAdminComponent, canActivateChild: [AuthGuardService] },
      // Dashboard User
      { path: 'dashboardUser', component: DashboardUserComponent, canActivateChild: [AuthGuardService] },
      // Learning Module Redirections Links
      { path: 'learning/learnBasicOfPatents', component: LearningBasicsComponent, canActivateChild: [AuthGuardService] },
      { path: 'learning/learnPatentDrawing', component: LearningDrawingComponent, canActivateChild: [AuthGuardService] },
      { path: 'learning/learnPatentSearch', component: LearningSearchComponent, canActivateChild: [AuthGuardService] },
      { path: 'learning/learnPatentDraft', component: LearningDraftComponent, canActivateChild: [AuthGuardService] },
      { path: 'learning/learnPatentFiling', component: LearningFilingComponent, canActivateChild: [AuthGuardService] },
      // Test Link
      { path: 'learning/basicOfPatentTest', component: TestBasicsComponent, canActivateChild: [AuthGuardService] },
      { path: 'learning/patentSearchTest', component: TestSearchComponent, canActivateChild: [AuthGuardService] },
      { path: 'learning/patentDraftTest', component: TestDraftComponent, canActivateChild: [AuthGuardService] },
      // NDA
      { path: 'nda', component: NdaComponent, canActivateChild: [AuthGuardService] },
      //My Account Based On userId
      { path: 'address', component: AddressComponent, canActivateChild: [AuthGuardService] },
      { path: 'address/:id', component: AddressComponent, resolve: { resolvedData: InventionResolver}, canActivateChild: [AuthGuardService] },
      // BasicInventionDetails Based On ProjectId
      { path: 'basicInventionDetails', component: BasicInventionDetailsSaveUpdateComponent, canActivateChild: [AuthGuardService] },
      { path: 'basicInventionDetails/:id', component: BasicInventionDetailsSaveUpdateComponent, resolve: { resolvedData: InventionResolver}, canActivateChild: [AuthGuardService] },
      // Patent Drawing Based On ProjectId
      // { path: 'patentDrawing', component: PatentDrawingSaveUpdateComponent, canActivateChild: [AuthGuardService] },
      { path: 'patentDrawing/:id', component: PatentDrawingSaveUpdateComponent, canActivateChild: [AuthGuardService] },
      //Patent Search Based On ProjectId
    // { path: 'patentSearch', component: PatentSearchComponent, canActivateChild: [AuthGuardService] },
      { path: 'patentSearch/:id', component: PatentSearchComponent, resolve: { resolvedData: InventionResolver}, canActivateChild: [AuthGuardService] },
      // Patent Draft Based On ProjectId
     // { path: 'patentDraft', component: PatentDraftSaveUpdateComponent, canActivateChild: [AuthGuardService] },
      { path: 'patentDraft/:id', component: PatentDraftSaveUpdateComponent, resolve: { resolvedData: InventionResolver}, canActivateChild: [AuthGuardService] },
      // Preview Based On ProjectId
     //  { path: 'preview', component: PreviewComponent, canActivateChild: [AuthGuardService] },
      { path: 'preview/:id', component: PreviewComponent, canActivateChild: [AuthGuardService] },
      // Project List Based On ProjectId
      { path: 'projectList/:id', component: ProjectListComponent, canActivateChild: [AuthGuardService] },
      // Patent filing process
      { path: 'patentFilingProcess', component: PatentFilingProcessComponent},
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: [],
})
export class AppRoutingModule {
}
